import { GITBOOK_DOCUMENTATOIN_BASE_URL } from '../../app/constants'
import { AdminDataTableSection, AdminPage, AdminPageHeader } from '../../common/components'
import { Text } from '../../common/designs'
import GetStartedSection from './GetStartedSection'

const LANDSCAPE_ANALYSIS_LINK = `${GITBOOK_DOCUMENTATOIN_BASE_URL}/data-collection/data-collection-studio#defining-settings-for-digital-landscape-analysis`
const UNSTRUCTURED_PROCESS_ANALYSIS_LINK = `${GITBOOK_DOCUMENTATOIN_BASE_URL}/data-collection/data-collection-studio#defining-settings-for-unstructured-process-analysis`
const STRUCTURED_PROCESS_ANALYSIS_LINK = `${GITBOOK_DOCUMENTATOIN_BASE_URL}/data-collection/data-collection-studio#defining-settings-for-structured-process-analysis`

const GetStarted = () => {
  return (
    <AdminPage width='full'>
      <AdminPageHeader
        title='Get Started With Process Intelligence Data Collection'
        description={
          <>
            <Text size='s' color='gray' className='leading-relaxed'>
              Welcome to the Process Intelligence admin panel: your place to turn on system, task,
              and process data collection.
            </Text>
            <Text size='s' color='gray' className='leading-relaxed'>
              Start with a simple setup and expand over time so you can grow into full process
              intelligence.
            </Text>
            <Text size='s' color='gray' className='leading-relaxed'>
              There are three analytic levels below—landscape, unstructured, and structured—each
              with documentation on GitBook.
            </Text>
          </>
        }
      />

      <AdminDataTableSection>
        <section aria-labelledby='get-started-steps-heading'>
          <div className='border-b border-gray-100 pb-4'>
            <Text variant='h3' size='l' weight={700} className='mb-1 leading-snug tracking-tight'>
              Setup path
            </Text>
            <Text size='xs' color='lightGray' className='max-w-xl leading-relaxed'>
              Follow the phases in order when you are new to data collection in this product.
            </Text>
          </div>

          <div className='divide-y divide-gray-100'>
            <GetStartedSection
              title='Digital landscape analysis'
              description='Optimize the use of resources, time, and cost.'
              orderString='01'
              instructionsLink={LANDSCAPE_ANALYSIS_LINK}
            />
            <GetStartedSection
              title='Unstructured process analysis'
              description='Discover and improve undocumented processes.'
              orderString='02'
              instructionsLink={UNSTRUCTURED_PROCESS_ANALYSIS_LINK}
            />
            <GetStartedSection
              title='Structured process analysis'
              description='Follow specific process objects to improve operations.'
              orderString='03'
              instructionsLink={STRUCTURED_PROCESS_ANALYSIS_LINK}
            />
          </div>
        </section>
      </AdminDataTableSection>
    </AdminPage>
  )
}

export default GetStarted

